module.exports = __webpack_public_path__ + "img/icon_rule.ed6ca976.svg";